export { XHRInstrumentation } from './instrumentation';

export { parseXHREvent } from './utils';
